import selectors from '../../../rootSelectors';
import { goToQuestion, goToInterstitial } from '../../../common/navigation/navigationActions';
import { SPELLING } from '../../../constants/measure';
import { resetQuestionsAndTimeTrackingState } from '../../../common/questions/questionsActions';
import { deactivateNextButton, blockScreen, unblockScreen } from '../../../common/screen/screenActions';
import { saveMeasureResponse } from '../../../common/api/spellingActions';
import { setPlaylistItemCompleted } from '../../../common/playlist/playlistActions';
import { stopQuestionTimeTracking } from '../../../common/timeTracking/timeTrackingActions';

export const saveSpellingResponse = (questionIndex, duration, isLastQuestion) => (dispatch, getStore) => {
    const state = getStore();
    const questionItemId = selectors.getSpellingQuestionItems(state, questionIndex).itemId;
    const formId = selectors.getSpellingFormId(state);
    const selectedResponse = selectors.getMultiChoiceResponses(state).join('');
    const language = selectors.getCurrentLanguage(state);

    return dispatch(saveMeasureResponse(
        SPELLING.MEASURE_API_KEY,
        questionItemId,
        questionIndex,
        formId,
        selectedResponse,
        duration,
        isLastQuestion,
        language,
    ));
};

export const onNextQuestionButtonClick = (questionIndex) => (dispatch, getStore) => {
    dispatch(blockScreen());
    dispatch(stopQuestionTimeTracking());

    const state = getStore();
    const isLastQuestion = (questionIndex) === selectors.getSpellingTotalQuestions(state);
    const language = selectors.getCurrentLanguage(state);
    const duration = selectors.getQuestionTimeTrackingDuration(state);

    return dispatch(saveSpellingResponse(questionIndex - 1, duration, isLastQuestion))
        .then(() => {
            const nextQuestion = questionIndex + 1;
            if (isLastQuestion) {
                dispatch(setPlaylistItemCompleted(SPELLING.ASSESSMENT, language));
                dispatch(goToInterstitial());
            } else {
                dispatch(unblockScreen());
                dispatch(deactivateNextButton());
                dispatch(resetQuestionsAndTimeTrackingState());
                dispatch(goToQuestion(SPELLING.ASSESSMENT, null, nextQuestion));
            }
        });
};
